/**
 * Homepage Search Auto-Open
 * On mobile homepage: Opens search popup on first user interaction.
 * Starts with inactive icon, activates on first touch/click.
 */
if (!window.Eurus.loadedScript.has('homepage-search-scroll.js')) {
  window.Eurus.loadedScript.add('homepage-search-scroll.js');

  if (window.innerWidth < 768) {
    const isHomepage = document.querySelector('main.theme-template-index') || 
                       document.body.classList.contains('template-index');
    
    if (isHomepage) {
      let hasTriggered = false;

      const triggerSearch = () => {
        if (hasTriggered) return;
        hasTriggered = true;

        setTimeout(() => {
          const searchButton = document.querySelector('.header-search #SearchOpen') ||
                              document.querySelector('#SearchOpen');
          if (searchButton) {
            searchButton.click();
          }
        }, 100);
      };

      const events = ['click', 'touchstart', 'scroll'];
      events.forEach(event => {
        const target = event === 'scroll' ? window : document;
        target.addEventListener(event, triggerSearch, { once: true, passive: true });
      });
    }
  }
}
